/*
 * BDM — Mention loi Évin dans la barre basse du footer.
 *
 * `sections/footer-utilities.liquid` n'accepte que trois types de blocs
 * (footer-copyright, footer-policy-list, social-links) et plafonne à 3 : impossible
 * d'y ajouter un texte libre depuis l'éditeur de thème. On insère donc la mention
 * en DOM réel, en fin de la barre, sans toucher au fichier de section du thème.
 *
 * 02/11/2026 : en anglais et en néerlandais (window.bdmLang), la mention traduite
 * est suivie de la mention française d'origine.
 *
 * Idempotent : ne fait rien si la mention est déjà présente (re-rendu de section
 * dans l'éditeur de thème, navigation avec transitions de vue).
 */
(function () {
  var FR = "L'abus d'alcool est dangereux pour la santé. À consommer avec modération.";
  var TEXTS = {
    fr: FR,
    en: 'Alcohol abuse is dangerous for your health. Drink in moderation. — ' + FR,
    nl: 'Overmatig alcoholgebruik is schadelijk voor de gezondheid. Geniet, maar drink met mate. — ' + FR
  };
  var LANG = String(window.bdmLang || 'fr').slice(0, 2).toLowerCase();
  var TEXT = TEXTS[LANG] || FR;
  var CLASS = 'bdm-legal-mention';

  function inject() {
    var bar = document.querySelector('.footer-utilities .utilities');
    if (!bar) return;
    if (bar.querySelector('.' + CLASS)) return;

    var p = document.createElement('p');
    p.className = CLASS;
    p.textContent = TEXT;
    bar.appendChild(p);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  /* L'éditeur de thème re-rend la section footer sans recharger la page. */
  document.addEventListener('shopify:section:load', inject);
})();
